import { defineStore } from 'pinia';

export const useLocationItemByLocationIdStore = defineStore('LocationItemsForLocationIds', () => {
  const inventoryAPI = useInventoryAPI();
  const settingsStore = useSettingsStore();
  //For material page
  const getLocationItemByLocationId = ref<MaterialItemApp[]>();
  const isFinalPage = ref<boolean>(false);

  //For location page
  const getLocationItemByLocationIdLocationPage = ref<MaterialItemApp[]>();
  const isFinalPageLocationPage = ref<boolean>(false);

  async function setLocationItemByLocationId(locationId: LocationItemForLocationIdsRequest, append: boolean = false) {
    const includeImages = settingsStore._settings.showWholesalerCatalogItemImages;
    const GetLocationItemsResponse: ResponseDTO<LocationItems> | undefined = await inventoryAPI.GetLocationItems(locationId, includeImages);

    if (GetLocationItemsResponse && !GetLocationItemsResponse.HasErrors) {

      if (append) {
        getLocationItemByLocationId.value?.push(...GetLocationItemsResponse.Data.Items);
      } else {
        getLocationItemByLocationId.value = GetLocationItemsResponse.Data.Items;
      }

      isFinalPage.value = GetLocationItemsResponse.Data.FinalPage;

      return getLocationItemByLocationId.value ?? [];

    }
  }

  async function setLocationItemByLocationIdLocationPage(locationId: LocationItemForLocationIdsRequest, append: boolean = false) {
    const includeImages = settingsStore._settings.showWholesalerCatalogItemImages;
    const GetLocationItemsResponse: ResponseDTO<LocationItems> | undefined = await inventoryAPI.GetLocationItems(locationId, includeImages);

    if (GetLocationItemsResponse && !GetLocationItemsResponse.HasErrors) {

      if (append) {
        getLocationItemByLocationIdLocationPage.value?.push(...GetLocationItemsResponse.Data.Items);
      } else {
        getLocationItemByLocationIdLocationPage.value = GetLocationItemsResponse.Data.Items;
      }

      isFinalPageLocationPage.value = GetLocationItemsResponse.Data.FinalPage;

      return getLocationItemByLocationIdLocationPage.value ?? [];

    }
  }

  return {
    _getLocationItemByLocationId: getLocationItemByLocationId,
    getLocationItemByLocationId: readonly(getLocationItemByLocationId),
    _isFinalPage: isFinalPage,
    isFinalPage: readonly(isFinalPage),
    setLocationItemByLocationId,

    _getLocationItemByLocationIdLocationPage: getLocationItemByLocationIdLocationPage,
    getLocationItemByLocationIdLocationPage: readonly(getLocationItemByLocationIdLocationPage),
    _isFinalPageLocationPage: isFinalPageLocationPage,
    isFinalPageLocationPage: readonly(isFinalPageLocationPage),
    setLocationItemByLocationIdLocationPage
  };
});
